var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "background" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "app-container" }, [
      _c("div", { staticClass: "section" }, [
        _c("h3", { staticClass: "section-title" }, [
          _vm._v("D-management ファイルの変換"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "section-text" }, [
          _vm._v(
            "\n        会員管理システム「D-management」をご利用の場合は、D-management から出力した\n        テキストファイルを取り込み用ファイルに変換することができます。\n      "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "section-text" }, [
          _vm._v("\n        下記ボタンから変換を行ってください。\n      "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "action-button convert-button",
                attrs: { type: "success", disabled: _vm.converting },
                on: { click: _vm.selectTxtFile },
              },
              [_vm._v("\n          ファイルを変換\n        ")]
            ),
            _vm._v(" "),
            _c("input", {
              ref: "txtFileInput",
              staticStyle: { display: "none" },
              attrs: { type: "file", accept: ".txt" },
              on: { change: _vm.handleTxtFileSelected },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section" },
        [
          _c("h3", { staticClass: "section-title" }, [
            _vm._v("ファイルの取り込み"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "section-text" }, [
            _vm._v(
              "\n        サンプルファイルまたは「D-management」変換ファイルを取り込んで会員登録を行ってください。\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "importForm",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                "label-width": "120px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "import-links" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "action-button sample-button",
                      on: { click: _vm.download },
                    },
                    [_vm._v("\n            サンプル\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "notice-link",
                      on: {
                        click: function ($event) {
                          _vm.noticeDialogVisible = true
                        },
                      },
                    },
                    [_vm._v("\n            取り込み時の注意点\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "import-actions" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "upload-form-item",
                      attrs: { prop: "excelFile", rules: _vm.rules.excelFile },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload",
                          attrs: {
                            accept: ".xlsx",
                            action: "",
                            "on-change": _vm.handleAddExcelFile,
                            "on-remove": _vm.handleRemoveExcelFile,
                            "file-list": _vm.excelFile,
                            limit: 1,
                            "show-file-list": false,
                            "auto-upload": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "action-button gray-outline-button",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            },
                            [
                              _vm._v(
                                "\n                ファイルを選択\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "action-button",
                      attrs: {
                        type: "primary",
                        disabled: _vm.centerDialogVisible,
                      },
                      on: { click: _vm.submitUpload },
                    },
                    [_vm._v("\n            取り込み\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "selected-file-area" }, [
                _vm.excelFile.length
                  ? _c("div", { staticClass: "selected-file-row" }, [
                      _c("i", {
                        staticClass: "el-icon-document selected-file-icon",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "selected-file-name" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.excelFile[0].name) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "selected-file-remove",
                          attrs: { type: "button" },
                          on: { click: _vm.removeSelectedFile },
                        },
                        [_c("i", { staticClass: "el-icon-close" })]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "確認",
                    visible: _vm.centerDialogVisible,
                    width: "600px",
                    "close-on-click-modal": false,
                    center: "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.centerDialogVisible = $event
                    },
                  },
                },
                [_c("span", [_vm._v("データをインポート中です。")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "strong-divider" }),
          _vm._v(" "),
          _vm.noticeDialogVisible
            ? _c("div", { staticClass: "notice-popup" }, [
                _c(
                  "button",
                  {
                    staticClass: "notice-popup-close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.noticeDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("\n          ×\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "notice-dialog-body" }, [
                  _c("p", [
                    _vm._v(
                      "・設立年月日の入力形式は以下のように入力をお願いします。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    例）2022年05月01日の場合")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    2022/5/1")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・入会年の入力形式は以下のように入力をお願いします。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    例）2022年05月01日の場合")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    2022または2022/5/1")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("・資本金の単位は万円になります。")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    例）100万円の場合")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("    100")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・「サンプル」ボタンをクリックしてダウンロードしたファイル(" +
                        _vm._s(_vm.introduceSample.importSampleName) +
                        ")に必要事項を入力してください。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "    ２行目は参考データの為、実際の「取り込み」時は行ごと削除をお願いします。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "    背景色：黄色のセルは必須入力項目となっております。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・郵便番号や住所などの数値は半角で入力してください。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・所属IDは＜所属ID対応表＞をご参照の上、半角で入力してください。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・各(" +
                        _vm._s(_vm.introduceSample.textProkuShibu) +
                        ")内の(" +
                        _vm._s(_vm.introduceSample.textShibuChiku) +
                        ")または委員会等を登録する場合は、該当する(" +
                        _vm._s(_vm.introduceSample.textShibuChiku) +
                        ")"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-left": "15px" } }, [
                    _vm._v("または委員会などの所属IDのみを入力してください。"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・委員会を登録する場合、上位の地区や支部を入力する必要はございません。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "・複数の所属IDを入力する際は半角のカンマ「,」で区切って入力してください。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("(例）"),
                    _vm.introduceSample.exampleName1
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.introduceSample.exampleName1) + "の"
                          ),
                        ])
                      : _vm._e(),
                    _vm.introduceSample.exampleName2
                      ? _c("span", [
                          _vm._v(
                            "「" + _vm._s(_vm.introduceSample.exampleName2)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "(" +
                        _vm._s(_vm.introduceSample.exampleNumber1) +
                        ")」の場合 " +
                        _vm._s(_vm.introduceSample.exampleNumber1)
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.introduceSample.exampleName4 &&
                  _vm.introduceSample.exampleNumber3
                    ? _c("p", [
                        _vm._v(
                          "(例）「" +
                            _vm._s(_vm.introduceSample.exampleName3) +
                            "(" +
                            _vm._s(_vm.introduceSample.exampleNumber2) +
                            ")」と「" +
                            _vm._s(_vm.introduceSample.exampleName4) +
                            "(" +
                            _vm._s(_vm.introduceSample.exampleNumber3) +
                            ")」の場合 " +
                            _vm._s(_vm.introduceSample.exampleNumber2) +
                            "," +
                            _vm._s(_vm.introduceSample.exampleNumber3)
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "affiliation-section" }, [
            _c(
              "div",
              { staticClass: "affiliation-left" },
              [
                _c("p", { staticClass: "affiliation-title" }, [
                  _vm._v("＜所属 ID 対応表＞"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "affiliation-search",
                  attrs: { placeholder: "検索" },
                  model: {
                    value: _vm.affiliationKeyword,
                    callback: function ($$v) {
                      _vm.affiliationKeyword = $$v
                    },
                    expression: "affiliationKeyword",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "affiliation-table" },
                  [
                    _c(
                      "el-row",
                      { staticClass: "titleTable" },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "grid-content-left" }, [
                            _c("span", [_vm._v("組織")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [_vm._v("ID")]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-tree", {
                      ref: "affiliationTree",
                      attrs: {
                        data: _vm.data,
                        "node-key": "id",
                        "default-expand-all": "",
                        "expand-on-click-node": false,
                        "filter-node-method": _vm.filterAffiliationNode,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var node = ref.node
                            var treeData = ref.data
                            return _c(
                              "span",
                              {
                                staticClass:
                                  "custom-tree-node clickable-tree-node",
                                class: {
                                  "selected-node":
                                    _vm.selectedAffiliationIds.includes(
                                      String(treeData.id)
                                    ),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.selectAffiliation(node, treeData)
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(node.label))]),
                                _vm._v(" "),
                                _c("span", { staticClass: "organizationId" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(treeData.id) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "affiliation-right" }, [
              _c("h3", { staticClass: "selected-id-title" }, [
                _vm._v("選択 ID"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "selected-id-text" }, [
                _vm._v("左の表から ID をクリックして選択してください。"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "selected-id-text" }, [
                _vm._v(
                  "選択した所属 ID を取り込みファイルに添付してください。"
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "selected-id-actions" },
                [
                  _c("el-input", {
                    staticClass: "selected-id-input",
                    attrs: {
                      value: _vm.selectedAffiliationText,
                      placeholder: "表示",
                      readonly: "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "copy-button",
                      on: { click: _vm.copySelectedIds },
                    },
                    [_vm._v("\n              コピー\n            ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.groupedSelectedAffiliations.length
                ? _c(
                    "div",
                    { staticClass: "selected-id-tree-groups" },
                    _vm._l(_vm.groupedSelectedAffiliations, function (group) {
                      return _c(
                        "div",
                        {
                          key: group.parentId,
                          staticClass: "selected-id-tree-group",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "selected-id-tree-parent" },
                            [
                              _c(
                                "span",
                                { staticClass: "selected-id-chip-text" },
                                [_vm._v(_vm._s(group.ids[0].id))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "selected-id-chip-remove",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeSelectedAffiliation(
                                        group.ids[0].id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  ×\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(group.ids.slice(1), function (item) {
                            return _c(
                              "div",
                              {
                                key: item.id,
                                class: [
                                  "selected-id-tree-child",
                                  "level-" + item.depth,
                                ],
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "selected-id-chip-text" },
                                  [_vm._v(_vm._s(item.id))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "selected-id-chip-remove",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeSelectedAffiliation(
                                          item.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  ×\n                "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h2", { staticClass: "page-title" }, [_vm._v("会員情報の取り込み")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }